var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-inline-flex rounded-lg overflow-hidden",
      attrs: { "data-comp": "UiCompletionStepper" },
    },
    _vm._l(_vm.steps, function (n) {
      return _c("div", {
        key: n,
        staticClass: "flex-grow-1",
        class: [n <= _vm.current ? _vm.statusClass : "bg-gray-200"],
        attrs: { "data-part": "step" },
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }